<template>
  <v-card class="files-save-panel">
    <div class="files-save-header">
      <v-icon small class="mr-1">mdi-content-save</v-icon>
      Save selected pages
    </div>

    <div class="files-save-body">
      <div v-if="selectedPages.length" class="mb-3">
        <div class="files-save-count mb-2">
          {{ selectedPages.length }}
          {{ selectedPages.length === 1 ? "page" : "pages" }} selected
        </div>
        <v-chip
          v-for="page in selectedPages"
          :key="page.key"
          small
          class="ma-1"
          outline
          color="success"
        >
          {{ page.fileName }} · p.{{ page.pageNumber }}
        </v-chip>
      </div>
      <div v-else class="files-save-empty">
        <v-icon class="files-save-empty-icon"
          >mdi-checkbox-blank-outline</v-icon
        >
        <div>Select pages to save.</div>
      </div>
      <div v-if="selectedPages.length">
        <div class="files-save-label mb-2">
          <v-icon small color="success" class="mr-1">mdi-file-document</v-icon>
          Document details
        </div>
        <v-select
         :menu-props="{ maxHeight: 600 }"
          outline
          hide-details
          class="mb-3"
          label="Save as"
          :items="docTypeItems"
          v-model="selectedDocTypeId"
          @change="onDocTypeChange"
        >
          <template slot="item" slot-scope="data">
            <v-list-tile-content>
              <v-list-tile-title
                :class="{ 'missing-doc-type': data.item.missingEntry }"
              >
                {{ data.item.description }}
              </v-list-tile-title>
            </v-list-tile-content>
          </template>
          <template slot="selection" slot-scope="data">
            {{ data.item.docTypeID }}
          </template>
        </v-select>

        <v-select
          :menu-props="{ maxHeight: 600 }"
          v-if="selectedDocTypeId && requireStudent"
          outline
          hide-details
          class="mb-3"
          label="Student"
          :items="studentItems"
          v-model="selectedStudentId"
        >
          <template slot="item" slot-scope="data">
            <v-list-tile-content>
              <v-list-tile-title>
                {{ data.item.description }}
              </v-list-tile-title>
            </v-list-tile-content>
          </template></v-select
        >

        <v-text-field
          v-if="selectedDocTypeId == 'CH205'"
          type="date"
          outline
          hide-details
          class="mb-3"
          label="Document Date"
          v-model="selectedDocumentDate"
        ></v-text-field>

        <v-text-field
          v-if="selectedFileName"
          :readonly="true"
          filled
          flat
          hide-details
          class="mb-3"
          label="Document name"
          required
          v-model="selectedFileName"
        ></v-text-field>

        <v-btn
          color="success"
          block
          class="files-save-btn"
          :disabled="!canSave"
          :loading="saving"
          @click="$emit('save')"
        >
          <v-icon left small>mdi-content-save</v-icon>
          Save document
        </v-btn>
      </div>
    </div>
  </v-card>
</template>
<script>
export default {
  name: "DocumentSplitterSavePanel",
  props: {
    accountId: {
      type: String,
      default: "",
    },
    students: {
      type: Array,
      default() {
        return [];
      },
    },
    docTypes: {
      type: Array,
      default() {
        return [];
      },
    },
    selectedPages: {
      type: Array,
      default() {
        return [];
      },
    },
    studentId: {
      type: String,
      default: "",
    },
    docTypeId: {
      type: String,
      default: "",
    },
    documentDate: {
      type: String,
      default: "",
    },
    fileName: {
      type: String,
      default: "",
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selectedStudentId: {
      get() {
        return this.studentId;
      },
      set(value) {
        this.$emit("update:studentId", value);
        if (value) {
          const student = this.students.find((s) => s.studentID === value);
          this.selectedFileName = `${this.selectedDocTypeId.trim()}_${this.studentName(
            student
          )}_${this.accountId.trim()}`;
        }
      },
    },
    selectedDocTypeId: {
      get() {
        return this.docTypeId;
      },
      set(value) {
        const [docTypeId, studentId] = value.split("|");
        this.$emit("update:docTypeId", docTypeId);
        if (studentId) {
          this.$emit("update:studentId", studentId);
          const student = this.students.find((s) => s.studentID === studentId);
          this.selectedFileName = `${docTypeId.trim()}_${this.studentName(
            student
          )}_${this.accountId.trim()}`;
        } else {
          this.selectedFileName = `${docTypeId.trim()}_${this.accountId.trim()}`;
        }
      },
    },
    selectedFileName: {
      get() {
        return this.fileName;
      },
      set(value) {
        this.$emit("update:fileName", value);
      },
    },
    selectedDocumentDate: {
      get() {
        return this.documentDate;
      },
      set(value) {
        this.$emit("update:documentDate", value);
      },
    },

    studentItems() {
      const items = [];
      this.students.forEach((student) => {
        const name = student.engName || student.hebName || student.studentID;
        // const desc = `${
        //   student.missingImm && this.selectedDocTypeId === "IMM"
        //     ? "- Missing: " + student.missingImm
        //     : ""
        // }
        //   ${
        //     student.missCH205 && this.selectedDocTypeId === "CH205"
        //       ? "- Missing CH205"
        //       : ""
        //   }
        // ${
        //   student.skipcard.includes("12 GRADE APPLICATION NOT SIGNED") &&
        //   this.selectedDocTypeId === "12G"
        //     ? "- Missing 12G"
        //     : ""
        // }
        // `;
        items.push({
          description: `${name} (${student.class})`,
          // isMissing: desc.trim() !== "",
          text: name,
          value: student.studentID,
        });
      });

      return items;
    },

    missingItems() {
      return this.docTypes
        .filter((type) => type.isMissing)
        .reduce((items, type) => {
          if (!type.requireStudent) {
            return items.concat({ type, student: null });
          }
          return items.concat(
            this.students
              .filter((student) =>
                this.isStudentMissingDoc(student, type.docTypeID)
              )
              .map((student) => ({
                type,
                student,
                missingDetail:
                  type.docTypeID === "IMM" ? student.missingImm : "",
              }))
          );
        }, []);
    },

    docTypeItems() {
      const allItems = this.docTypes.map((type) => ({
        ...type,
        text: type.docTypeID,
        description: this.docTypeLabel(type),
        value: type.docTypeID,
        color: "success",
      }));
      const missingItems = this.missingItems.map(
        ({ type, student, missingDetail }) => {
          const label =
            this.docTypeLabel(type) +
            (missingDetail ? ` - ${missingDetail}` : "") +
            (student ? " - " + this.studentName(student) : "");
          return {
            ...type,
            text: student
              ? `${type.docTypeID} - ${this.studentName(student)}`
              : type.docTypeID,
            description: label,
            value: student
              ? type.docTypeID + "|" + student.studentID
              : type.docTypeID + "|",
            color: "error",
            missingEntry: true,
          };
        }
      );

      return missingItems.length
        ? [...missingItems, { divider: true }, ...allItems]
        : allItems;
    },
    requireStudent() {
      return this.docTypes.find((type) => type.docTypeID === this.docTypeId)
        .requireStudent;
    },

    canSave() {
      if (this.selectedDocTypeId == "CH205" && !this.selectedDocumentDate) {
        return false;
      }
      if (
        !this.selectedPages.length ||
        this.saving ||
        !this.docTypeId ||
        !this.fileName
      ) {
        return false;
      }
      if (this.requireStudent && !this.studentId) {
        return false;
      }
      return true;
    },
  },
  methods: {
    studentName(student) {
      return (
        (student &&
          (student.engName || student.hebName || student.studentID)) ||
        ""
      ).trim();
    },
    docTypeLabel(type) {
      const id = type.docTypeID;
      const desc = type.docDescription;
      return id && desc && desc !== id ? `${id} (${desc})` : desc || id;
    },
    isStudentMissingDoc(student, docTypeID) {
      return docTypeID == "IMM"
        ? student.missingImm
        : docTypeID == "CH205"
        ? student.missCH205
        : (student.skipcard || "").includes("12 GRADE APPLICATION NOT SIGNED");
    },
    onDocTypeChange(value) {
      // v-select re-emits change on blur with the current value; ignore it
      if (value === this.docTypeId || value.split("|")[1]) {
        return;
      }
      this.selectedStudentId = "";
    },
  },
};
</script>
<style>
.files-save-panel {
  position: sticky;
  border-radius: 8px !important;
  overflow: hidden;
}

.files-save-header {
  display: flex;
  align-items: center;
  background: #4caf50;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  padding: 12px 16px;
}

.files-save-header .v-icon {
  color: #fff !important;
}

.files-save-body {
  padding: 16px;
}

.files-save-count {
  font-size: 12px;
  font-weight: 700;
  color: #4caf50;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.files-save-label {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 700;
  color: #4caf50;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.files-save-empty {
  text-align: center;
  color: #9e9e9e;
  padding: 24px 8px 8px;
  font-size: 13px;
}

.files-save-empty-icon {
  display: block;
  font-size: 36px !important;
  color: #c8e6c9 !important;
  margin-bottom: 8px;
}

.files-save-btn {
  text-transform: none !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  margin-top: 4px;
}

.missing-doc-type {
  color: #f44336 !important;
}
</style>
